import React from 'react';

const ResponsiveTable = ({ 
  headers, 
  data, 
  renderRow, 
  emptyMessage = "No data available",
  loading = false
}) => {
  // For mobile view, we'll use a card-based layout
  const isMobile = window.innerWidth < 640;
  
  if (loading) {
    return (
      <div className="px-4 py-6 whitespace-nowrap text-sm text-gray-500 text-center">
        Loading...
      </div>
    );
  }
  
  if (!data || data.length === 0) {
    return (
      <div className="px-4 py-6 whitespace-nowrap text-sm text-gray-500 text-center">
        {emptyMessage}
      </div>
    );
  }
  
  if (isMobile) {
    // Mobile list view - simpler rows with subtle divider
    return (
      <div className="px-4">
        {data.map((item, index) => (
          <div key={index} className={`py-3 ${index < data.length - 1 ? 'border-b border-gray-200' : ''}`}>
            {renderRow(item, true)}
          </div>
        ))}
      </div>
    );
  }
  
  // Desktop table view
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          {headers.map((header, index) => (
            <th 
              key={index} 
              scope="col" 
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {data.map((item, index) => (
          <tr key={index} className="hover:bg-gray-50">
            {renderRow(item, false)}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ResponsiveTable;